__turbopack_context__.v({
  "inner": "RecipeResults-module-scss-module__gvqx6W__inner",
  "landscape": "RecipeResults-module-scss-module__gvqx6W__landscape",
  "listItem": "RecipeResults-module-scss-module__gvqx6W__listItem",
  "listItem--no-results": "RecipeResults-module-scss-module__gvqx6W__listItem--no-results",
  "listItem--no-results-filler": "RecipeResults-module-scss-module__gvqx6W__listItem--no-results-filler",
  "root": "RecipeResults-module-scss-module__gvqx6W__root",
  "show": "RecipeResults-module-scss-module__gvqx6W__show",
  "showMoreContainer": "RecipeResults-module-scss-module__gvqx6W__showMoreContainer",
  "zeroState": "RecipeResults-module-scss-module__gvqx6W__zeroState",
  "zeroStateInner": "RecipeResults-module-scss-module__gvqx6W__zeroStateInner",
  "zeroStateText": "RecipeResults-module-scss-module__gvqx6W__zeroStateText",
});
